import { AD_ENTITY_TYPES } from '@silverfort-nodelibs/common/utils/consts';
import { Icons } from '@silverfort/sf-components';

export const ENTITIES_TYPES_ITEMS_CONFIG = {
    [AD_ENTITY_TYPES.USER]: {
        tooltip: 'Account',
        icon: Icons.User
    },
    [AD_ENTITY_TYPES.GROUP]: {
        tooltip: 'Security group',
        icon: Icons.UserGroup
    },
    [AD_ENTITY_TYPES.OU]: {
        tooltip: 'Organizational unit',
        icon: Icons.Folder
    },
    [AD_ENTITY_TYPES.HOST]: {
        tooltip: 'Server',
        icon: Icons.Server
    },
    [AD_ENTITY_TYPES.SERVER]: {
        tooltip: 'Server',
        icon: Icons.Server
    }
};
